module.exports = __webpack_public_path__ + "img/jitong.be28d350.png";